import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faCrown } from "@fortawesome/free-solid-svg-icons/faCrown";
import { faUser } from "@fortawesome/free-solid-svg-icons/faUser";
import { faUserTie } from "@fortawesome/free-solid-svg-icons/faUserTie";

import { TeamRole } from "../../../model/permissions/types/TeamRole.enum";
import { ThemeType } from "../../../theme/Theme";

interface TeamRoleStyle {
  icon: IconProp;
  color: keyof ThemeType;
}

export const TEAM_ROLE_STYLE: Record<TeamRole, TeamRoleStyle> = {
  [TeamRole.OWNER]: { icon: faCrown, color: "caution" },
  [TeamRole.MANAGER]: { icon: faUserTie, color: "accent" },
  [TeamRole.STAFF]: { icon: faUser, color: "darkerSub" },
};
